// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-breadcrumbs {
  display: flex;
  align-items: center;
  line-height: 1.6;
  padding: 16px 12px;
}
:where(.vuetify-styles) .v-breadcrumbs--rounded {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-breadcrumbs--density-default {
  padding-top: 16px;
  padding-bottom: 16px;
}

:where(.vuetify-styles) .v-breadcrumbs--density-comfortable {
  padding-top: 12px;
  padding-bottom: 12px;
}

:where(.vuetify-styles) .v-breadcrumbs--density-compact {
  padding-top: 8px;
  padding-bottom: 8px;
}

:where(.vuetify-styles) .v-breadcrumbs__prepend {
  align-items: center;
  display: inline-flex;
}

:where(.vuetify-styles) .v-breadcrumbs-item {
  align-items: center;
  color: inherit;
  display: inline-flex;
  padding: 0 4px;
  text-decoration: none;
  vertical-align: middle;
}
:where(.vuetify-styles) .v-breadcrumbs-item--disabled {
  opacity: var(--v-disabled-opacity);
  pointer-events: none;
}
:where(.vuetify-styles) .v-breadcrumbs-item--link {
  color: inherit;
  text-decoration: none;
}
:where(.vuetify-styles) .v-breadcrumbs-item--link:hover {
  text-decoration: underline;
}
:where(.vuetify-styles) .v-breadcrumbs-item .v-icon {
  font-size: 1rem;
  margin-inline: -4px 2px;
}

:where(.vuetify-styles) .v-breadcrumbs-divider {
  display: inline-block;
  padding: 0 8px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VBreadcrumbs/VBreadcrumbs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".v-breadcrumbs {\n  display: flex;\n  align-items: center;\n  line-height: 1.6;\n  padding: 16px 12px;\n}\n.v-breadcrumbs--rounded {\n  border-radius: 4px;\n}\n.v-breadcrumbs--density-default {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n\n.v-breadcrumbs--density-comfortable {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.v-breadcrumbs--density-compact {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.v-breadcrumbs__prepend {\n  align-items: center;\n  display: inline-flex;\n}\n\n.v-breadcrumbs-item {\n  align-items: center;\n  color: inherit;\n  display: inline-flex;\n  padding: 0 4px;\n  text-decoration: none;\n  vertical-align: middle;\n}\n.v-breadcrumbs-item--disabled {\n  opacity: var(--v-disabled-opacity);\n  pointer-events: none;\n}\n.v-breadcrumbs-item--link {\n  color: inherit;\n  text-decoration: none;\n}\n.v-breadcrumbs-item--link:hover {\n  text-decoration: underline;\n}\n.v-breadcrumbs-item .v-icon {\n  font-size: 1rem;\n  margin-inline: -4px 2px;\n}\n\n.v-breadcrumbs-divider {\n  display: inline-block;\n  padding: 0 8px;\n  vertical-align: middle;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
